/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import { getSfExecutions } from "services/getStepFunctionData";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import { Execution } from "types/List/List.interface";
import { NoDataFound } from "utils/constants";
import { Chip, DataTableView, DatePicker, Button } from "cubee2e-cube-global-components";
import { PaginationShape } from "cubee2e-cube-global-components/dist/src/types";
import dayjs, { Dayjs } from "dayjs";
import { dataTableHeaders } from "utils/defaultValues";
import { useAppDispatch, useAppSelector } from "hooks";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export default function Home() {
  const homeSelector = useAppSelector((state) => state.home.home);
  const dispatch = useAppDispatch();
  const [executions, setExecutions] = useState<Execution[]>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [datePickerOpen, setDatePickerOpen] = useState<boolean>(false);
  const [date, setDate] = useState<Dayjs | null>(dayjs(homeSelector.date ?? dayjs(), "MM-DD-YYYY"));
  const [limitCount, setLimitCount] = useState<number>(25);
  const [pageCount, setPageCount] = useState<number>(0);
  const [offsetCount, setOffsetCount] = useState<number>(0);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const icons = (iconLabel: string, iconName = "") => {
    return (
      <Chip
        label={iconLabel ? iconLabel : ""}
        colorScheme="iconBlue"
        iconName={iconName ? iconName : ""}
        freeText
      ></Chip>
    );
  };
  const handleDateChange = async () => {
    setLoader(true);
    dispatch({ type: "home/homeSetDate", payload: dayjs(date).format("MM-DD-YYYY") });
    const data = await getSfExecutions({ ProcessDate: dayjs(date).format("YYYY-MM-DD") });
    if (data === false) {
      setExecutions([]);
    } else if (data.statusCode === 200 && data.payload[0]?.status === NoDataFound) {
      setExecutions([]);
    } else {
      const modifiedData: Execution[] = [];
      interface data {
        referencelink: string;
        flowdetailid: string;
        status: string;
        createdDate: string;
        plantsourcecode: string;
        salesseriesname: string;
      }
      data?.payload?.map((item: data, index: number) => {
        const dateObject = new Date(item.createdDate);
        const cstDateTime = dayjs(dateObject).tz("America/Chicago").format("YYYY-MM-DD HH:mm:ss");
        const datePart = dateObject.toISOString().split("T")[0];
        // const timePart = dateObject.toISOString().split("T")[1].split(".")[0];
        modifiedData.push({
          sNo: index + 1,
          urn: item.referencelink.split("-")[0],
          soldOrderNumber: item.referencelink.split("-")[1],
          dealerCode: item.referencelink.split("-")[2],
          flowdetailid: item.flowdetailid,
          status: item.status == "scheduled" ? "IN PROGRESS" : item.status.toUpperCase(),
          date: datePart,
          time: cstDateTime,
          plantsourcecode: item.plantsourcecode ?? "",
          salesseriesname: item.salesseriesname ?? "",
          NsoIcon: icons("", "VisibilityOutlined"),
          SIMIcon: icons("", "VisibilityOutlined"),
        });
      });
      // console.log(modifiedData);
      setExecutions(modifiedData);
    }
    setLoader(false);
  };
  const handleDate = (date: Dayjs | null) => {
    setDate(date);
    dispatch({ type: "homeSetDate", payload: date });
  };
  const setPagination = (data: any) => {
    // console.log("data", data);
    const pageSize = data.size;
    const newPage = data.page;
    const currentOffset = offsetCount as number;

    let newOffsetCount = currentOffset;

    if (newPage > pageCount) {
      newOffsetCount = currentOffset + pageSize;
    } else if (newPage < pageCount) {
      newOffsetCount = Math.max(currentOffset - pageSize, 0);
    } else if (newPage === 0) {
      newOffsetCount = 0;
    }
    setOffsetCount(newOffsetCount);
    setPageCount(newPage);
    setLimitCount(pageSize);
  };
  const navigate = useNavigate();
  const handleSimIconClick = (data: any) => {
    console.log(data.row);
    dispatch({ type: "home/homeSetSimFlowData", payload: data.row });
    dispatch({ type: "home/setHomeStatus", payload: data.row.status });
    dispatch({ type: "simFlow/simFlowSetActiveStep", payload: 0 });
    dispatch({ type: "simFlow/simFlowStateReset" });
    dispatch({ type: "errors/clearSimError" });
    navigate(`/simEngineFlow/${data?.row?.flowdetailid}`);
  };
  const handleNsoIconClick = (data: any) => {
    dispatch({ type: "nsoFlow/nsoFlowSetActiveStep", payload: 0 });
    dispatch({ type: "home/setHomeStatus", payload: data.row.status });
    dispatch({ type: "nsoFlow/nsoFlowStateReset" });
    dispatch({ type: "errors/clearNsoError" });
    dispatch({ type: "home/homeSetNsoFlowData", payload: data.row });
    navigate(`/dataCoreFlow/${data?.row?.flowdetailid}`);
  };
  // console.log(executions);
  useEffect(() => {
    // if (localStorage.getItem("token") === null) {
    //   navigate("/");
    // }
    if (executions.length === 0) {
      handleDateChange();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className="flex flex-col justify-center align-center items-center App">
        <div className="py-8 flex flex-row gap-4 App">
          <DatePicker
            open={datePickerOpen}
            value={date}
            disablePastDays={false}
            handleOpen={(value: any) => {
              setDatePickerOpen(value);
            }}
            handleChange={(e: any) => handleDate(e.$d)}
          />
          <Button label="Fetch Results" onClick={handleDateChange} variant={"secondary"} />
        </div>
      </div>
      <DataTableView
        viewByModalTitle={""}
        viewByModalData={[]}
        tableHeader={{
          title: "All Requests",
          viewlabel: "",
          sortLabel: "",
          tableCount: `${executions.length} items`,
        }}
        handleSelectedRowBarIcons={function (_field: any): void {}}
        tableData={{
          rowsData: executions,
          dropDownOptions: [],
          loading: loader,
          reloading: false,
          count: executions.length,
        }}
        pagination={{ page: pageCount, size: limitCount }}
        handleDeleteFilter={function (_field: string): void {}}
        handleReset={function (): void {}}
        handleApplyFilter={function (_value: any): void {}}
        filters={{
          appliedFilters: [],
        }}
        handleApplyCustomizeColumns={function (_field: any[]): void {}}
        handleFilteredRows={function (_filter: any): void {}}
        handlePaginationUpdatedRows={function (_info: PaginationShape.pageInfo): void {}}
        handleApplyTable={function (_value: any): void {}}
        handleDataTableUpdate={function (_value: any): void {}}
        inlineFilterColumns={[]}
        getSelectedRowBarIcons
        columns={[]}
        currentColumns={dataTableHeaders}
        handleRowCellClick={function (data: any): void {
          if (data?.column?.field === "NsoIcon") {
            // console.log(data);
            handleNsoIconClick(data);
          }
          if (data?.column?.field === "SIMIcon") {
            handleSimIconClick(data);
          }
        }}
        handleClear={function (_value: any): void {}}
        setInlineFilterValues={function (_value: any): void {}}
        handleSelectedItemUpdate={function (selectedItem): void {}}
        handleCurrentColumnUpdate={function (updatedColumn): void {}}
        handleCurrentSortUpdate={function (sortedColumns): void {}}
        handlePagination={setPagination}
        toastNotification={{
          isEnabled: false,
          type: "",
          field: "",
        }}
      />
    </>
  );
}
